import z from 'zod';
import arrayUtil from '../../util/arrayUtil';

export type ResultsSearchParams = z.infer<typeof resultsSearchParamsSchema>;
export const resultsSearchParamsSchema = z.object({
  category: z.string(),
  flavours: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
  tastes: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
  mouthfeels: z.string().optional().transform((val) => val ? arrayUtil.removeEmptyStrings(val.split(',')) : []),
});
